import $ from 'jquery';
import FocusTrap from 'focus-trap';
import Keyboard from 'keyboard-key';
import Viewport from './Viewport';
import Search from './Search';

const defaults = {
  menuClass: 'menu-active',
  searchClass: 'search-active',
  buttons: {
    menu: '.menu-icon',
    search: '.search-icon',
    close: '.close-icon',
  },
  components: {
    flyout: '#flyout',
    search: '#dd-search',
    header: '.page-header',
  },
};

export default class Toolbar {
  constructor(element, options) {
    this.element = element;
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.Search = this.addSearchLogic();
    this.FocusTrap = this.addFocusTrapLogic();
    this.listen();
  }

  // Add search logic to manage the various states of the search component

  addSearchLogic() {
    return this.searchComponent ? new Search(this.searchComponent) : false;
  }

  // Add focus-trap logic to manage focus state when flyout is expanded.

  addFocusTrapLogic() {
    return new FocusTrap(this.headerComponent, {
      initialFocus: this.flyoutComponent,
    });
  }

  // Manage click events.

  clickHandler(event) {
    const menuActive = document.body.classList.contains(this.settings.menuClass);
    const searchActive = document.body.classList.contains(this.settings.searchClass);
    const isActive = menuActive || searchActive;
    const isSearch = event.currentTarget === this.searchButton;

    if (isActive) {
      this.deactivate();
    } else {
      this.activate(isSearch);
    }
  }

  // Manage keydown events.

  keyDownHandler(event) {
    const keyCode = Keyboard.getCode(event);
    if (keyCode === Keyboard.Escape) {
      this.deactivate();
    }
  }

  // Activates the flyout and all of the associated buttons.

  activate(search) {
    const activeClass = search ? this.settings.searchClass : this.settings.menuClass;
    document.body.classList.add(activeClass);
    this.menuButton.setAttribute('aria-expanded', !search);
    this.searchButton.setAttribute('aria-expanded', search);
    this.closeButton.setAttribute('aria-expanded', !search);

    if (search && !Viewport.mobileState) {
      $(document.querySelector('.headerlinks')).fadeOut(100);
      $(document.querySelector('.toolbar .social-links')).fadeOut(100);
    }

    // Leverage the focus trap logic to lock active element focus
    // within the flyout only (on mobile devices specifically).
    if (Viewport.mobileState) {
      this.FocusTrap.activate();
    }

    if (search && this.Search) {
      // Leverage the Search logic to manage it's focus in state.
      this.Search.focusIn();
    } else {
      // If the menu button is clicked, focus the flyout container.
      this.flyoutComponent.focus();
    }
  }

  // Deactivates the flyout and all of the associated buttons.

  deactivate() {
    this.FocusTrap.deactivate();
    document.body.classList.remove(this.settings.menuClass);
    document.body.classList.remove(this.settings.searchClass);
    this.menuButton.setAttribute('aria-expanded', false);
    this.searchButton.setAttribute('aria-expanded', false);
    this.closeButton.setAttribute('aria-expanded', false);

    // Leverage the Search logic to manage it's focus out state.

    if (this.Search) {
      this.Search.focusOut();
      $(document.querySelector('.headerlinks')).css('display', 'inline-block');
      $(document.querySelector('.toolbar .social-links')).css('display', 'inline-block');
    }
  }

  // Set up event listeners to help control the various states of the toolbar and flyout.

  listen() {
    this.element.addEventListener('keydown', this.keyDownHandler.bind(this));
    this.menuButton.addEventListener('click', this.clickHandler.bind(this));
    this.searchButton.addEventListener('click', this.clickHandler.bind(this));
    this.closeButton.addEventListener('click', this.clickHandler.bind(this));
  }

  // Getters of the various components available

  get menuButton() {
    return this.element.querySelector(this.settings.buttons.menu);
  }

  get searchButton() {
    return this.element.querySelector(this.settings.buttons.search);
  }

  get closeButton() {
    return document.querySelector(this.settings.buttons.close);
  }

  get flyoutComponent() {
    return document.querySelector(this.settings.components.flyout);
  }

  get searchComponent() {
    return document.querySelector(this.settings.components.search);
  }

  get headerComponent() {
    return document.querySelector(this.settings.components.header);
  }
}
